<script>
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import { mapActions } from "vuex";

export default {
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    InputGroup
  },
  data() {
    return {
      loader: false,
      name: this.address.name,
      complement: this.address.complement,
      reference: this.address.reference
    };
  },

  methods: {
    ...mapActions("addresses", ["update"]),

    async submit() {
      this.loader = true;

      try {
        let valid = await this.$validator.validateAll();
        if (!valid) throw "Ops, temos um erro nos dados informados!";

        let id = this.address.id;
        let { name, complement, reference } = this;
        await this.update({ id, name, complement, reference });

        this.$emit("updated", this.address);
      } catch (e) {
        this.$toasted.error(e);
      }

      this.loader = false;
    }
  }
};
</script>

<template>
  <modal
    title="EDITAR ENDEREÇO"
    subtitle="Edite os dados do endereço"
    size="md"
    @close="$emit('close')"
  >
    <template slot="body">
      <div class="form-group">
        <input-group
          :error="errors.first('nome')"
          v-model="name"
          v-validate="'required|min:2|max:255'"
          name="nome"
          label="nome ex: (casa, escritório...)"
        />
      </div>

      <div class="form-group">
        <input-group
          :error="errors.first('rua')"
          :value="address.street"
          v-validate="'required|max:255'"
          label="rua"
          disabled
        />

        <input-group
          :error="errors.first('numero')"
          :value="address.street_number"
          v-validate="'required|numeric|max:31'"
          name="numero"
          label="número"
          disabled
        />

        <input-group
          :error="errors.first('complemento')"
          v-model="complement"
          v-validate="'min:2|max:255'"
          label="complemento"
        />
      </div>

      <div class="form-group">
        <input-group
          :error="errors.first('cidade')"
          :value="address.district.city.display_name"
          label="cidade"
          disabled
        />

        <input-group
          :error="errors.first('uf')"
          :value="address.district.city.state.code"
          label="uf"
          disabled
        />

        <input-group
          :error="errors.first('bairro')"
          :value="address.district.display_name"
          label="bairro"
          disabled
        />
      </div>

      <div class="form-group">
        <input-group
          :error="errors.first('cep')"
          :value="address.zip_code"
          v-validate="'required|length:8|numeric'"
          label="cep"
          disabled
        />

        <input-group
          :error="errors.first('referencia')"
          v-model="reference"
          v-validate="'min:5|max:255'"
          name="referencia"
          label="referência"
        />
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">fechar</button>
      <button class="btn bg-purple" :class="{'btn--loading': loader}" @click="submit">
        <span>atualizar</span>
      </button>
    </template>
  </modal>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/EditAddress.vue